import * as actionTypes from "../actionTypes";

const initialState = {
    subAdminData: [],
};

const subAdminReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_SUB_ADMIN: {
            return {
                ...state,
                subAdminData: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default subAdminReducer;
